<div class="quarter-container">
  <div class="date-header">{{headerName}}</div>
    <div class="quarter-calendar">
 <!-- Left Panel -->
<div class="quarter-panel">
  <div class="year-nav">
    <button mat-icon-button class="nav-button prev" (click)="moveStartYearPrevious()" [disabled]="!canMoveStartPrevious"></button>
    <span>{{ startYear }} - {{ startYear + 2 }}</span>
    <button mat-icon-button class="nav-button next" (click)="moveStartYearNext()" [disabled]="!canMoveStartNext"></button>
  </div>

  <div class="quarters-grid">
    <div class="quarter-range" *ngFor="let quarter of leftQuarters">
      <div 
        class="quarter-range-button-highlight" 
        [class.in-range]="isInRange(quarter)"
        [class.leftcurve]="quarter.includes('Q1') || quarter.includes(selectedStartQuarter)"
        [class.rightcurve]="quarter.includes('Q4') || quarter.includes(selectedEndQuarter)"
      >
        <button
          class="quarter-button"
          [class.selected]="isSelected(quarter)"
          [class.in-range]="isInRange(quarter)"
          [class.leftdisabled]="isDisabled(quarter)"
          [class.buttonleftcurve]="quarter.includes('Q1') || quarter.includes(selectedStartQuarter)"
          [class.buttonrightcurve]="quarter.includes('Q4') || quarter.includes(selectedEndQuarter)"
          (click)="selectQuarter(quarter,'start')"
        >
          {{ quarter }}
        </button>
      </div>
    </div>
  </div>
</div>

  
      <!-- Divider -->
      <div class="divider"></div>
  
      <!-- Right Panel -->
<div class="quarter-panel">
  <div class="year-nav">
    <button mat-icon-button class="nav-button prev" 
            (click)="moveEndYearPrevious()"  
            [disabled]="!canMoveEndPrevious">
    </button>
    <span>{{ endYear }} - {{ endYear + 2 }}</span>
    <button mat-icon-button class="nav-button next" 
            (click)="moveEndYearNext()" 
            aria-label="Next year" 
            [disabled]="!canMoveEndNext">
    </button>
  </div>

  <div class="quarters-grid">
    <div class="quarter-range" *ngFor="let quarter of rightQuarters">
      <div class="quarter-range-button-highlight" 
           [class.in-range]="isInRange(quarter)"
           [class.leftcurve]="quarter.includes('Q1') || quarter === selectedStartQuarter"
           [class.rightcurve]="quarter.includes('Q4') || quarter === selectedEndQuarter">
        
        <button
          class="quarter-button"
          [class.selected]="isSelected(quarter)"
          [class.in-range]="isInRange(quarter)"
          [class.leftdisabled]="isDisabled(quarter)"
          [class.buttonleftcurve]="quarter.includes('Q1') || quarter === selectedStartQuarter"
          [class.buttonrightcurve]="quarter.includes('Q4') || quarter === selectedEndQuarter"
          (click)="selectQuarter(quarter, 'end')"
        >
          {{ quarter }}
        </button>

      </div>
    </div>
  </div>
</div>

</div>
    <!-- Date Inputs -->
    <div class="date-inputs">
      <div class="input-group">
        <span class="input-group-text">Start Date</span>
        <input
          type="text"
          class="form-control"
          [value]="selectedStartQuarter ? (getQuarterStartDate(selectedStartQuarter) | date: 'MM.dd.yyyy') : ''"
          readonly
        />
      </div>
      <div class="input-group">
        <span class="input-group-text">End Date</span>
        <input
          type="text"
          class="form-control"
          [value]="selectedEndQuarter ? (getQuarterEndDate(selectedEndQuarter) | date: 'MM.dd.yyyy') : ''"
          readonly
        />
      </div>
    </div>
  
    <!-- Actions -->
    <div class="actions">
      <button matTooltip="Clear Selection" class="btn clear" (click)="clearDates()">Clear</button>
      <button
        matTooltip="Apply Selection"
        class="btn apply"
        cdkMenu
        [disabled]="!selectedStartQuarter || !selectedEndQuarter"
        (click)="applyDates()"
      >
        Apply
      </button>
    </div>
  </div>
